// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1CGJr","file":"styles_file__3AJK6"};